const CameraLock = (): React.JSX.Element => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" fill="none" viewBox="0 0 23 18">
        <path stroke="#fff" strokeLinejoin="bevel" strokeWidth="1.5" d="M15.077 6.385V1H2v5.385m13.077 0L22 3.308v9.23l-6.923-3.076m0-3.077v3.077m0 0v5.384H11.5" />
        <path stroke="#fff" strokeWidth="1.5" d="M4.308 4.077h2.307" />
        <path stroke="#fff" strokeLinejoin="bevel" strokeWidth="1.2" d="M9 16.714H1V11h8v5.714ZM2.714 11V9.286a2.286 2.286 0 0 1 4.571 0V11m-.572 2v2" />
    </svg>
}

export default CameraLock